export default __webpack_public_path__ + "static/media/payment-method-amex.c326e84c.png";